import React, { useState } from "react";
import { checkInt, convertToFloat } from "../../CommonMethhods/CommonMethods";

function TaxTable(props) {
  const { data, seg, totalValues, totalPnl, selection, detailedTaxReportType } = props;

  const [taxPercentIntraday, setTaxPercentIntraday] = useState(30);
  const [taxPercentShortTerm, setTaxPercentShortTerm] = useState(15);
  const [taxPercentLongTerm, setTaxPercentLongTerm] = useState(10);
  const [taxPercentFOTax, setTaxPercentFOTax] = useState(15);

  function onChangeValueIntraday(e) {
    if (
      e.target.value &&
      checkInt(e.target.value) &&
      e.target.value > 0 &&
      e.target.value < 100
    )
      setTaxPercentIntraday(e.target.value);
    else if (!e.target.value) setTaxPercentIntraday(e.target.value);
  }

  function onChangeValueShortTerm(e) {
    if (
      e.target.value &&
      checkInt(e.target.value) &&
      e.target.value > 0 &&
      e.target.value < 100
    )
      setTaxPercentShortTerm(e.target.value);
    else if (!e.target.value) setTaxPercentShortTerm(e.target.value);
  }

  function onChangeValueLongTerm(e) {
    if (
      e.target.value &&
      checkInt(e.target.value) &&
      e.target.value > 0 &&
      e.target.value < 100
    )
      setTaxPercentLongTerm(e.target.value);
    else if (!e.target.value) setTaxPercentLongTerm(e.target.value);
  }

  function onChangeValueFOTax(e) {
    if (
      e.target.value &&
      checkInt(e.target.value) &&
      e.target.value > 0 &&
      e.target.value < 100
    )
      setTaxPercentFOTax(e.target.value);
    else if (!e.target.value) setTaxPercentFOTax(e.target.value);
  }

  const shortTermCalc = (value, percentile) => {
    return convertToFloat((value * percentile) / 100);
  };

  const shortTermCalcForZero = (value, percentile) => {
    return convertToFloat((value * percentile) / 100);
  };
  return (
    <>
      {seg === "fo" && selection === "taxreport" && (
        <div className="tax-apporximate">
          <div>APPROXIMATE TAX TO BE PAID FOR</div>
          <div className="name-symobol">
            <span>@</span>
            <input
              className="input-tax"
              type="number"
              value={taxPercentFOTax}
              onChange={onChangeValueFOTax}
              placeholder="0"
            ></input>
            <span>%</span>
          </div>
          <div className="tax-val">
            (₹) ={shortTermCalcForZero(totalPnl, taxPercentFOTax)}
          </div>
        </div>
      )}
      <div className="table-responsive scroll-table report-table-wrapper tax-table mt-8">
        <table className="table last-column">
          {selection === "taxreport" ? (
            <>
              <thead>
                {seg === "eq" && (
                  <tr className="stock-tr">
                    <th scope="col" className="first-th">
                      Scrip Name
                    </th>
                    <th scope="col" className="isin-th-tax">
                      ISIN
                    </th>
                    <th scope="col">
                      <div className="tax-th">
                        <div> Intraday</div>
                        {/* <div className="name-symobol">
                          <span>@</span>
                          <input
                            className="input-tax"
                            type="number"
                            value={taxPercentIntraday}
                            onChange={onChangeValueIntraday}
                            placeholder="0"
                          ></input>
                          <span>%</span>
                        </div>
                        <div className="tax-val">
                          (₹) =
                          {shortTermCalcForZero(
                            totalValues.totalintraDayPl,
                            taxPercentIntraday
                          )}
                        </div> */}
                      </div>
                    </th>

                    <th scope="col">
                      <div className="tax-th">
                        <div>Short Term </div>
                        {/* <div className="name-symobol">
                          <span>@</span>
                          <input
                            className="input-tax"
                            type="number"
                            value={taxPercentShortTerm}
                            onChange={onChangeValueShortTerm}
                            placeholder="0"
                          ></input>
                          <span>%</span>
                        </div>
                        <div className="tax-val">
                          (₹) =
                          {shortTermCalcForZero(
                            totalValues.totalShortTrmPl,
                            taxPercentShortTerm
                          )}
                        </div> */}
                      </div>
                    </th>
                    <th scope="col ">
                      <div className="tax-th">
                        <div>Long Term</div>
                        {/* <div className="name-symobol">
                          <span>@</span>
                          <input
                            className="input-tax"
                            type="number"
                            value={taxPercentLongTerm}
                            onChange={onChangeValueLongTerm}
                            placeholder="0"
                          ></input>
                          <span>%</span>
                        </div>
                        <div className="tax-val">
                          (₹) =
                          {shortTermCalcForZero(
                            totalValues.totalLongTermPl,
                            taxPercentLongTerm
                          )}
                        </div> */}
                      </div>
                    </th>
                  </tr>
                )}
                {seg === "fo" || seg === "curfo" || seg === "com" ? (
                  <>
                    <tr className="">
                      <th scope="col">Symbol</th>
                      <th scope="col">Expiry Date</th>
                      <th scope="col">Instrument Type</th>
                      <th scope="col">Option Type</th>
                      <th scope="col">Strike Price</th>
                      <th scope="col">Profit Loss</th>
                    </tr>
                  </>
                ) : (
                  ""
                )}
              </thead>
              {seg === "eq" && (
                <tbody className="tax-body">
                  {data &&
                    data.map((item, key) => {
                      return (
                        <>
                          <tr key={key}>
                            <td rowSpan={2} className="td-first-day">
                              {item?.scripName || "-"}
                            </td>
                            <td rowSpan={2} className="td-isin-tax">
                              {item?.isin || "-"}
                            </td>

                            <td className="tax-pnl">P/L</td>

                            <td>₹ {item?.intraDayPl || 0.0}</td>

                            <td>₹ {item?.shortTrmPl || 0.0}</td>

                            <td>₹ {item?.longTermPl || 0.0}</td>
                          </tr>
                          <tr>
                            <td className="td-isin-tax border-bottom"></td>
                            <td className="td-isin-tax border-bottom"></td>
                            <td className="tax-pnl">TAX</td>
                            <td>
                              <span>
                                ₹
                                {shortTermCalc(
                                  item?.intraDayPl,
                                  taxPercentIntraday
                                )}
                              </span>
                            </td>
                            <td>
                              <span>
                                ₹
                                {shortTermCalc(
                                  item?.shortTrmPl,
                                  taxPercentShortTerm
                                )}
                              </span>
                            </td>

                            <td>
                              <span>
                                ₹
                                {shortTermCalc(
                                  item?.longTermPl,
                                  taxPercentLongTerm
                                )}
                              </span>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>
              )}
              {seg === "fo" || seg === "curfo" || seg === "com" ? (
                <tbody>
                  {data &&
                    data.map((item, key) => {
                      return (
                        <>
                          <tr key={key} className="">
                            <td>{item?.symbol || "-"}</td>
                            <td>{item?.expiryDate || "-"}</td>
                            <td>{item?.instrumentType || 0}</td>
                            <td>{item?.optionType || 0}</td>
                            <td>{item?.strikePrice || 0}</td>
                            <td>{item?.profitLoss || 0}</td>
                            {/* <td className="w-25">
                              <span>
                                ₹
                                {shortTermCalc(
                                  item?.profitLoss,
                                  taxPercentFOTax
                                )}
                              </span>
                            </td> */}
                          </tr>
                        </>
                      );
                    })}
                </tbody>
              ) : (
                ""
              )}
              {seg === "eq" && (
                // <tfoot className="tax-total-values">
                //   {/* <tr>
                //     <td>Total</td>
                //     <td className="width-150-tax"></td>

                //     <td>{totalValues.totalintraDayPl}</td>
                //     <td>{totalValues.totalShortTrmPl}</td>
                //     <td>{totalValues.totalLongTermPl}</td>
                //   </tr> */}
                //   <tr>
                //     <td rowSpan={2} colSpan={2} className="td-first-day">
                //       Total
                //     </td>
                //     <td rowSpan={2} className="td-first-day">
                //     </td>
                //     <td className="tax-pnl">P/L</td>

                //     <td>{totalValues.totalintraDayPl}</td>

                //     <td>{totalValues.totalShortTrmPl}</td>

                //     <td>{totalValues.totalLongTermPl}</td>
                //   </tr>
                //   {/* <tr>
                //     <td className="td-isin-tax border-bottom"></td>
                //     <td className="td-isin-tax border-bottom"></td>
                //     <td className="tax-pnl">TAX</td>
                //     <td>
                //       <span>
                //         {totalValues?.totalintraDayTax}
                //       </span>
                //     </td>
                //     <td>
                //       <span>
                //         {
                //           totalValues?.totalShortTrmTax
                //         }
                //       </span>
                //     </td>

                //     <td>
                //       <span>

                //         {totalValues?.totalLongTermTax}
                //       </span>
                //     </td>
                //   </tr> */}
                // </tfoot>
                <>
                  <tfoot className="totalVal">
                    <tr>
                      <td rowSpan={2} className="td-first-day">Total</td>
                      <td rowSpan={2} className="td-isin-tax"></td>
                      <td className="tax-pnl">P/L</td>
                      <td>{totalValues.totalintraDayPl}</td>
                      <td>{totalValues.totalShortTrmPl}</td>
                      <td>{totalValues.totalLongTermPl}</td>
                    </tr>
                    <tr>
                      <td className="td-first-day"></td>
                      <td className="td-isin-tax"></td>
                      <td className="tax-pnl">TAX</td>
                      <td>{totalValues.totalintraDayTax}</td>
                      <td>{totalValues.totalShortTrmTax}</td>
                      <td>{totalValues.totalLongTermTax}</td>
                    </tr>
                  </tfoot>
                </>
              )}
              {seg === "fo" || seg === "curfo" || seg === "com" ? (
                <tbody className="tax-total-values">
                  <tr>
                    <td></td>
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{totalPnl}</td>
                  </tr>
                </tbody>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              <thead>
                <tr>
                {seg === "eq" && (
                  <>
                      <th scope="col">Scrip Name</th>
                      <th scope="col">ISIN</th>
                      
                      {detailedTaxReportType !== "inclusive_all_taxes" ? (
                        <>
                          <th>Party Code</th>
                          <th>Buy Qty.</th>
                          <th>Buy Date</th>
                          <th>Buy Rate</th>
                          <th>Buy Avg.</th>
                          <th>Sell Qty.</th>
                          <th>Sell Date</th>
                          <th>Sell Rate</th>
                          <th>Sell Avg.</th>
                          <th>Gross PNL</th>
                        </>
                      ): (
                        <>
                          <th scope="col">Intraday Gain/Loss</th>
                          <th scope="col">Intraday Gain/Loss Tax</th>
                          <th scope="col">ShortTerm Gain/Loss</th>
                          <th scope="col">ShortTerm Gain/Loss Tax</th>
                          <th scope="col">LongTerm Gain/Loss</th>
                          <th scope="col">LongTerm Gain/Loss Tax</th>
                        </>
                      )}
                  </>
                )}
                {seg === "fo" && (
                  <>
                    <th scope="col">Symbol</th>
                    <th scope="col">Instrument Type</th>
                    <th scope="col">Option Type</th>
                    <th scope="col">Expiry Date</th>
                    <th scope="col">Strike Price</th>
                    <th scope="col">Net Qty.</th>
                    <th scope="col">Buy Rate</th>
                    <th scope="col">Buy Qty.</th>
                    <th scope="col">Sell Rate</th>
                    <th scope="col">Sell Qty.</th>
                    <th scope="col">Realised PNL</th>
                    <th scope="col">Tax</th>
                  </>
                )}
                {seg === "curfo" && (
                  <>
                    <th scope="col">Symbol</th>
                    <th scope="col">Expiry Date</th>
                    <th scope="col">Instrument Type</th>
                    <th scope="col">Option Type</th>
                    <th scope="col">Strike Price</th>
                    <th scope="col">Profit Loss</th>
                  </>
                )}
                {seg === "com" && (
                  <>
                    <th scope="col">Symbol</th>
                    <th scope="col">Instrument Type</th>
                    <th scope="col">Option Type</th>
                    <th scope="col">Expiry Date</th>
                    <th scope="col">Strike Price</th>
                    <th scope="col">Net Qty.</th>
                    <th scope="col">Buy Rate</th>
                    <th scope="col">Buy Qty.</th>
                    <th scope="col">Sell Rate</th>
                    <th scope="col">Sell Qty.</th>
                    <th scope="col">Realised PNL</th>
                    <th scope="col">Tax</th>
                  </>
                )}
                </tr>
              </thead>
              <tbody>
                {seg === "eq" && data &&
                  data.map((item, key) => {
                    return (
                      <tr key={key} className="">
                        <td>{item?.scrip || "-"}</td>
                        <td>{item?.isin || "-"}</td>
                        {detailedTaxReportType !== "inclusive_all_taxes" ? (
                          <>
                            <td>{item?.partyCode || "-"}</td>
                            <td>{item?.buyQty || 0}</td>
                            <td>{item?.buyDate || "-"}</td>
                            <td>{item?.buyValue || 0}</td>
                            <td>{item?.buyAvgPrice || 0}</td>
                            <td>{item?.sellQty || 0}</td>
                            <td>{item?.sellDate || 0}</td>
                            <td>{item?.sellValue || 0}</td>
                            <td>{item?.sellAvgPrice || 0}</td>
                            <td>{item?.grossPnl || 0}</td>
                          </>
                        ): (
                          <> 
                            <td>{item?.intraDayPl || 0}</td>
                            <td>{item?.intraDayTax || 0}</td>
                            <td>{item?.shortTrmPl || 0}</td>
                            <td>{item?.shortTrmTax || 0}</td>
                            <td>{item?.longTermPl || 0}</td>
                            <td>{item?.longTermTax || 0}</td>
                          </>
                        )}
                        </tr>
                    );
                  })}
                {seg === "fo" &&
                  data &&
                  data.map((item, key) => {
                    return (
                      <>
                        <tr key={key} className="">
                          <td>{item.symbol}</td>
                          <td>{item.instrumentType}</td>
                          <td>{item.optionType}</td>
                          <td>{item.expiryDate}</td>
                          <td>{item.strikePrice}</td>
                          <td>{item.netQty}</td>
                          <td>{item.buyRate}</td>
                          <td>{item.buyQty}</td>
                          <td>{item.sellRate}</td>
                          <td>{item.sellQty}</td>
                          <td>{item.realisedPnl}</td>
                          <td>{item.tax}</td>
                        </tr>
                      </>
                    );
                  })}
                {seg === "curfo" &&
                  data &&
                  data.map((item, key) => {
                    return (
                      <>
                        <tr key={key} className="">
                          <td>{item.symbol || "-"}</td>
                          <td>{item.expiryDate || "-"}</td>
                          <td>{item.instrumentType || "-"}</td>
                          <td>{item.optionType || "-"}</td>
                          <td>{item.strikePrice || 0}</td>
                          <td>{item.profitLoss || 0}</td>
                        </tr>
                      </>
                    );
                  })}
                {seg === "com" &&
                  data &&
                  data.map((item, key) => {
                    return (
                      <>
                        <tr key={key} className="">
                          <td>{item.symbol || "-"}</td>
                          <td>{item.instrumentType || "-"}</td>
                          <td>{item.optionType || "-"}</td>
                          <td>{item.expiryDate || "-"}</td>
                          <td>{item.strikePrice || 0}</td>
                          <td>{item.netQty || 0}</td>
                          <td>{item.buyRate || 0}</td>
                          <td>{item.buyQty || 0}</td>
                          <td>{item.sellRate || 0}</td>
                          <td>{item.sellQty || 0}</td>
                          <td>{item.realisedPnl || 0}</td>
                          <td>{item.tax || 0}</td>
                        </tr>
                      </>
                    );
                  })}
              </tbody>

              {/* {seg === "curfo" && (
                <tbody className="tax-total-values">
                  <tr>
                    <td></td>
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{totalPnl}</td>
                  </tr>
                </tbody>
              )} */}
              {/* {seg === "fo" && (
                <tbody className="tax-total-values">
                  <tr>
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              )} */}
              {/* {seg === "eq" && (
                <tbody className="tax-total-values">
                  <tr>
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              )} */}
            </>
          )}
        </table>
      </div>
    </>
  );
}
export default TaxTable;
